import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import axios from "axios";
import Code from "components/SmallComponents/Code";
import StatusCapsule from "components/SmallComponents/StatusCapsule";
import Pagination from "pages/Pagination/Pagination";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { BsDownload } from "react-icons/bs";
import { CiWarning } from "react-icons/ci";
import { FaCheck, FaEye, FaFilePdf } from "react-icons/fa6";
import { MdCancel, MdDelete, MdDone } from "react-icons/md";
import { RiAiGenerate, RiDeleteBin6Line } from "react-icons/ri";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import actionbuttonCustomStyle, {
  CustomOption,
} from "styles/actionbuttonCustomStyle.";
import Swal from "sweetalert2";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const CreditNoteList = forwardRef(
  (
    {
      searchParameter,
      searchParameter2,
      searchCompanySpecificCriteriaId,
      searchCompanySpecificDateRangeId,
      formDate,
      toDate,
    },
    ref
  ) => {
    const [creditNoteList, setCreditNoteList] = useState([]);
    const gridRef = useRef();
    const data = useRef([]);
    const selectRef = useRef();
    const [inventoryMovement, setInventoryMovement] = useState(false);
    const [submitObj, setSubmitObj] = useState({
      id: "",
      company_warehouse_id: "",
      fin_credit_note_status_id: 2,
      inventory_movement: false,
    });

    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [wareHouse, setWareHouse] = useState([]);
    const token = sessionStorage.getItem("token");
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const [erplist, setErplist] = useState([]);

    useEffect(() => {
      // Retrieving data from sessionStorage
      const storedErplist = sessionStorage.getItem("erplist");
      if (storedErplist) {
        try {
          // Parsing the JSON string to an array of objects
          const parsedErplist = JSON.parse(storedErplist);
          setErplist(parsedErplist);
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }
      }
    }, []);

    const showActionColumn = erplist.some(
      (item) => item.erp_module_id === 59 && item.update
    );

    const showViewColumn = erplist.some(
      (item) => item.erp_module_id === 59 && item.view
    );

    const [count, setCount] = useState();
    const [recordPerPage, setRecordPerPage] = useState(200);
    const [page, setPage] = useState(1);
    const [offsetforSR, setOffsetforSR] = useState();
    // const [searchParameter, setsearchParameter] = useState("");

    useEffect(() => {
      companywarehouseget();
    }, []);

    useEffect(() => {
      getCreditNote();
    }, [
      searchParameter,
      searchParameter2,
      searchCompanySpecificCriteriaId,
      searchCompanySpecificDateRangeId,
      page,
      recordPerPage,
    ]);

    const updatedActionButtonCustomStyle = {
      ...actionbuttonCustomStyle,
      control: (base) => ({
        ...base, // Spread the existing `control` styles
        backgroundColor: "transparent",
        border: "none",
        boxShadow: "none",
        cursor: "pointer",
        width: "150px", // Set the desired width here
        "&:hover": {
          border: "none",
        },
      }),
      menu: (base) => ({
        ...base,
        marginTop: "0px", // Space above the menu
        marginRight: "100px", // Space on the right of the menu
        marginBottom: "0", // Space below the menu
        marginLeft: "0px", // Space on the left of the menu
        paddingTop: "0", // Space inside the top of the menu container
        paddingRight: "0", // Space inside the right of the menu container
        paddingBottom: "0", // Space inside the bottom of the menu container
        paddingLeft: "0", // Space inside the left of the menu container
        zIndex: 9999,
      }),
    };

    const getCreditNote = () => {
      var offset = (page - 1) * recordPerPage;
      setOffsetforSR((page - 1) * recordPerPage);
      var limit = recordPerPage;
      console.log(offset);

      const requestPayload = {
        // Include other properties from obj
        offset,
        limit,
        search_company_specific_criteria_id: searchCompanySpecificCriteriaId,
        search_company_specific_date_range_id: searchCompanySpecificDateRangeId,
        search_parameter: searchParameter || searchParameter2,
      };
      console.log(requestPayload);

      axios
        .post(
          "/api/purple-fusion/creditnote/getforpagging",
          requestPayload,
          headers
        )
        .then((response) => {
          console.log(response.data);
          const sortedData = [...response.data].sort((a, b) => b.id - a.id);
          setCount(response.data[0]?.count);
          setCreditNoteList(sortedData);
          data.current = sortedData;
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    const companywarehouseget = () => {
      axios
        .post("/api/purple-fusion/companywarehouse/get", {}, headers)
        .then((response) => {
          // Assuming response.data is an array of warehouse objects
          const formattedOptions = response.data.map((warehouse) => ({
            value: warehouse.id, // Use a unique identifier
            label: warehouse.warehouse_name, // Use a meaningful display name
          }));

          setWareHouse(formattedOptions);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    useImperativeHandle(
      ref,
      () => ({
        downloadExcel: () => {
          onBtnExport();
        },

        downloadPdf: () => {
          DownloadPDF();
        },
      }),
      []
    );

    const DownloadPDF = () => {
      const docDefinition = {
        pageOrientation: "portrait",
        header: {
          text: "Credit Note List",
          style: "header",
        },
        content: [
          {
            style: "tableExample",
            table: {
              body: [
                [
                  { text: "SNO.", style: "tableHeader", bold: true },
                  { text: "CUSTOMER NAME", style: "tableHeader", bold: true },
                  {
                    text: "TAX INVOICE CODE",
                    style: "tableHeader",
                    bold: true,
                  },
                  {
                    text: "CREDIT NOTE CODE",
                    style: "tableHeader",
                    bold: true,
                  },
                  {
                    text: "CREDIT NOTE NUMBER",
                    style: "tableHeader",
                    bold: true,
                  },
                  { text: "STATUS", style: "tableHeader", bold: true },
                  {
                    text: "REASON FOR CREDIT NOTE",
                    style: "tableHeader",
                    bold: true,
                  },
                  {
                    text: "CREDIT NOTE DATE",
                    style: "tableHeader",
                    bold: true,
                  },
                  { text: "ACTIVE", style: "tableHeader", bold: true },
                  { text: "CREATED DATE", style: "tableHeader", bold: true },
                ],
                ...(data.current?.map((creditNote, index) => [
                  index + 1, // SNO.
                  creditNote.customer_name || "",
                  creditNote.tax_invoice_code || "",
                  creditNote.code || "",
                  creditNote.debit_note_number || "",
                  creditNote.fin_credit_note_status || "",
                  creditNote.reason_for_credit_note || "",
                  creditNote.credit_note_date || "",
                  creditNote.isactive ? "Yes" : "No",
                  creditNote.createdon || "",
                ]) || []),
              ],
              widths: "auto",
            },
            layout: {
              fillColor: function (rowIndex, node, columnIndex) {
                return rowIndex === 0 ? "#CCCCCC" : null;
              },
            },
          },
        ],
        styles: {
          tableExample: {
            fontSize: 8, // Set the font size to a smaller value
            color: "#333",
          },
          tableHeader: {
            bold: true,
            fontSize: 10, // You can set a different font size for headers if needed
            color: "#000",
          },
          header: {
            fontSize: 18,
            bold: true,
            margin: [10, 10, 10, 20],
            // Add underline
            color: "#333",
          },
        },
      };
      pdfMake.createPdf(docDefinition).download("Credit Note List");
    };

    const onBtnExport = useCallback(() => {
      const excludedFields = ["id"]; // Fields to exclude from the export

      const visibleColumns = customColDefs.filter(
        (column) => !excludedFields.includes(column.field)
      );

      const options = {
        fileName: "Credit Note List.csv", // Specify your desired filename here
        columnKeys: visibleColumns.map((column) => column.field),
        processCellCallback: (params) => {
          if (params.column.getColId() === "isactive") {
            return params.value ? "Yes" : "No";
          }
          return params.value;
        },
      };
      // Export data with updated options
      gridRef.current.api.exportDataAsCsv(options);
    }, []);

    const handleDownloadCustomerDebitNote = async (params) => {
      console.log(params);
      try {
        const requestData = {
          id: params,
        };

        const response = await axios.post(
          "/api/purple-fusion/creditnote/downloads",
          requestData,
          {
            ...headers,
            responseType: "arraybuffer",
          }
        );

        const contentDisposition = response.headers["content-disposition"];
        const FileName = response.headers["content-disposition"];
        const contentType = response.headers["content-type"];

        // Extract file name from content disposition
        const fileNameMatch = contentDisposition.match(
          /filename=["']?([^'"\s]+)["']?/
        );
        const fileName = fileNameMatch ? fileNameMatch[1] : "download";

        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: contentType });

        // Create a URL for the file
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${FileName}.pdf`; // Use the extracted filename directly
        document.body.appendChild(a);

        // Trigger a click event to start the download
        a.click();

        // Remove the download link from the DOM
        document.body.removeChild(a);

        // Revoke the Object URL to free up resources
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    };
    const handleDownloadOriginalCreditNote = async (params) => {
      console.log(params);
      try {
        const requestData = {
          fin_credit_note_id: params.data.id,
          fin_credit_note_document_type_id: 1,
        };

        const response = await axios.post(
          "/api/purple-fusion/creditnote/pdf/downloads",
          requestData,
          {
            ...headers,
            responseType: "arraybuffer",
          }
        );

        const contentDisposition = response.headers["content-disposition"];
        const FileName = response.headers["content-disposition"];
        const contentType = response.headers["content-type"];

        // Extract file name from content disposition
        const fileNameMatch = contentDisposition.match(
          /filename=["']?([^'"\s]+)["']?/
        );
        const fileName = fileNameMatch ? fileNameMatch[1] : "download";

        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: contentType });

        // Create a URL for the file
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${params.data.code}.pdf`; // Use the extracted filename directly
        document.body.appendChild(a);

        // Trigger a click event to start the download
        a.click();

        // Remove the download link from the DOM
        document.body.removeChild(a);

        // Revoke the Object URL to free up resources
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    };
    const handleDownloadAllCopyCreditNote = async (params) => {
      console.log(params);
      try {
        const requestData = {
          fin_credit_note_id: params.data.id,
          fin_credit_note_document_type_id: 5,
        };

        const response = await axios.post(
          "/api/purple-fusion/creditnote/pdf/downloads",
          requestData,
          {
            ...headers,
            responseType: "arraybuffer",
          }
        );

        const contentDisposition = response.headers["content-disposition"];
        const FileName = response.headers["content-disposition"];
        const contentType = response.headers["content-type"];

        // Extract file name from content disposition
        const fileNameMatch = contentDisposition.match(
          /filename=["']?([^'"\s]+)["']?/
        );
        const fileName = fileNameMatch ? fileNameMatch[1] : "download";

        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: contentType });

        // Create a URL for the file
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${params.data.code}.pdf`; // Use the extracted filename directly
        document.body.appendChild(a);

        // Trigger a click event to start the download
        a.click();

        // Remove the download link from the DOM
        document.body.removeChild(a);

        // Revoke the Object URL to free up resources
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    };

    const GetPreview = async (params, name) => {
      console.log(name);
      try {
        const requestData = {
          id: params,
        };
        console.log(requestData);

        const response = await axios.post(
          "/api/purple-fusion/creditnote/preview",
          requestData,
          {
            ...headers,
            responseType: "arraybuffer",
          }
        );
        // const contentDisposition = response.headers["content-disposition"];
        const FileName = response.headers["content-disposition"];

        // const contentType = response.headers["content-type"];
        const contentType = "application/pdf";
        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: contentType });

        // Check if the Blob type is supported before creating an Object URL
        if (Blob.prototype.hasOwnProperty("arrayBuffer")) {
          const arrayBuffer = await blob.arrayBuffer();
          const url = window.URL.createObjectURL(
            new Blob([arrayBuffer], { type: contentType })
          );

          // Open a new tab and set its location to the Object URL
          window.open(url);

          // Revoke the Object URL to free up resources
          window.URL.revokeObjectURL(url);
        } else {
          console.error(
            "Blob.arrayBuffer is not supported. Unable to create Object URL."
          );
        }
      } catch (error) {
        console.error("Error downloading file:", error);
        toast.warning("Unable to download file. Please try again later.");
      }
    };

    const deleteDraftTaxInvoice = (id) => {
      Swal.fire({
        title: "Are you sure?",
        html: `You want to delete 
        <span style="color: #FF5733;"></span>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      })
        .then((result) => {
          if (result.isConfirmed) {
            axios
              .put(
                "/api/purple-fusion/creditnote/deletedraftnote",
                { id: id },
                headers
              )
              .then((response) => {
                console.log(response.data);
                const message = response.data.message;
                if (response.data.status) {
                  toast.success(message, {
                    autoClose: 1000,
                  });
                  getCreditNote();
                } else {
                  toast.error(message, {
                    autoClose: 1000,
                  });
                }
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const generateEInvoice = (id) => {
      Swal.fire({
        title: "Are you sure?",
        html: `You want to Submit <span style="color: #FF5733;"></span>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Submit it!",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Processing...",
            text: "Please wait while we generate your e-invoice.",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios
            .post(
              "/api/purple-fusion/einvoice/creditnote/einv",
              { credit_note_id: id },
              headers
            )
            .then((response) => {
              console.log(response.data);

              let message = response.data.message;
              message = message.replace(/[\[\]{}\/\\"']/g, "");
              message = message.replace(/[\,\;]/g, "\n");
              console.log(message);

              Swal.close(); // Close the Swal modal

              if (response.data.status) {
                toast.success(message, {
                  autoClose: 1000,
                });
                getCreditNote();
              } else {
                toast.error(message, {
                  autoClose: 1000,
                });
              }
            })
            .catch((error) => {
              console.log(error);
              Swal.close(); // Close the Swal modal on error
              toast.error("An error occurred. Please try again.", {
                autoClose: 2000,
              });
            });
        }
      });
    };

    const handleSubmit = (obj) => {
      console.log("Submit clicked with:", obj);

      if (obj.inventory_movement && !obj.company_warehouse_id) {
        toast.error("Please select a warehouse", {
          autoClose: 2000,
        });
        return;
      }

      axios
        .put("/api/purple-fusion/creditnote/update", obj, headers)
        .then((response) => {
          console.log(response.data);
          const message = response.data.message;
          response.data.status
            ? toast.success(message, {
                autoClose: 2000,
                onClose: () => {
                  setIsOpen(false);
                  getCreditNote();
                },
              })
            : toast.error(message, {
                autoClose: 2000,
                onClose: () => {},
              });
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const handleNavigation = (option) => {
      console.log("Navigate to:", option.value);
      const params = option.params;

      switch (option.value) {
        case "View":
          navigate(`/creditNote/item/${params.data.id}`, {
            state: {
              tax_invoice_id: params.data.tax_invoice_id,
            },
          });
          break;
        case "Preview":
          GetPreview(params.data.id, params.data.code);
          break;
        case "Delete":
          deleteDraftTaxInvoice(params.data.id);
          break;
        case "Cancel":
          navigate(`/creditnote/cancel/einvoice/${params.data.id}`, {
            state: {
              irn: params.data.irn,
              fin_credit_note_status_id: params.data.fin_credit_note_status_id,
              fin_customer_debit_note_id:
                params.data.fin_customer_debit_note_id,
            },
          });
          break;
        case "Submit":
          const updatedObj = {
            ...submitObj,
            id: params.data.id,
            fin_credit_note_status_id: 2,
            company_warehouse_id: "",
            inventory_movement: params.data.inventory_movement,
          };

          setSubmitObj(updatedObj); // Keep the state updated

          if (params.data.inventory_movement) {
            setIsOpen(true); // Open modal
          } else {
            handleSubmit(updatedObj); // Pass latest data
          }
          break;
        case "Download Debit Note":
          handleDownloadCustomerDebitNote(params.data.id);
          break;
        case "DownloadOriginal":
          handleDownloadOriginalCreditNote(params);
          break;
        case "DownloadAllCopy":
          handleDownloadAllCopyCreditNote(params);
          break;

        case "E-Invoice":
          generateEInvoice(params.data.id);
          break;
        default:
          break;
      }
    };

    const defaultColDefs = [
      { headerName: "SNO.", field: "sr", width: 80 },
      { headerName: "CUSTOMER NAME", field: "customer_name", width: 200 },
      { headerName: "TAX INVOICE CODE", field: "tax_invoice_code", width: 150 },
      {
        headerName: "CREDIT NOTE CODE",
        field: "code",
        width: 150,
        cellRenderer: (params) => <Code>{params.value}</Code>,
      },
      {
        headerName: "DEBIT NOTE NUMBER",
        field: "debit_note_number",
        width: 120,
        cellClass: "font-semibold",
      },
      {
        headerName: "STATUS",
        field: "fin_credit_note_status",
        width: 130,
        cellRenderer: (params) => (
          // <>
          //   {params.data.fin_credit_note_status === "Submitted" ? (
          //     <span class=" text-green-500 ">{params.value}</span>
          //   ) : (
          //     <span class=" text-red-500  ">{params.value}</span>
          //   )}
          // </>
          <>
            <StatusCapsule
              type={
                params.data.fin_credit_note_status === "Submitted"
                  ? "success"
                  : "error"
              }
            >
              {params.value}
            </StatusCapsule>
          </>
        ),
      },
      {
        headerName: "REASON FOR CREDIT NOTE",
        field: "reason_for_credit_note",
        width: 200,
      },
      {
        headerName: "CREDIT NOTE DATE",
        field: "credit_note_date",
        width: 120,
      },
      { headerName: "ACTIVE", field: "isactive", width: 120 },
      // { headerName: "ACTIVE", field: "inventory_movement", width: 120 },

      {
        headerName: "CREADED DATE",
        field: "createdon",
        width: 120,
      },
      {
        headerName: "DEBIT NOTE",
        field: "fin_customer_debit_note_id",
        cellRenderer: (params) =>
          params.data.fin_customer_debit_note_id ? (
            <button
              className="font-small text-blue-600 dark:text-blue-500 "
              onClick={(e) => {
                handleDownloadCustomerDebitNote(params.value);
              }}
              title="ORIGINAL COPY"
            >
              {/* Download One  */}
              <BsDownload className="w-4 h-4" />
            </button>
          ) : null,
        width: 120,
      },
      {
        headerName: "DELETE",
        field: "id",
        cellRenderer: (params) =>
          params.data.fin_credit_note_status === "Draft" ? (
            <button
              className="font-small"
              onClick={(e) => {
                deleteDraftTaxInvoice(params.value);
              }}
              title="Delete"
            >
              <MdDelete className="w-4 h-4" color="red" />
            </button>
          ) : null,
        width: 100,
      },
      {
        headerName: "SUBMIT",
        field: "id",
        cellRenderer: (params) =>
          params.data.fin_credit_note_status === "Draft" ? (
            <div className="my-2">
              <button
                onClick={() => {
                  const updatedObj = {
                    ...submitObj,
                    id: params.data.id,
                    fin_credit_note_status_id: 2,
                    company_warehouse_id: "",
                    inventory_movement: params.data.inventory_movement,
                  };
                  console.log(updatedObj);

                  setSubmitObj(updatedObj); // keep your state updated

                  if (params.data.inventory_movement) {
                    setIsOpen(true);
                  } else {
                    handleSubmit(updatedObj); // pass the correct data
                  }
                }}
                className="bg-transparent hover:bg-green-500 p-1 hover:text-black-900 text-blue-700 font-semibold hover:text-white border border-blue-500 hover:border-transparent rounded"
              >
                Submit
              </button>
            </div>
          ) : null,
        width: 100,
      },
      {
        headerName: "E-INVOICE",
        field: "id",
        cellRenderer: (params) =>
          params.data.irn ? (
            <span className="text-green-500 text-xs">Generated</span>
          ) : params.data.fin_credit_note_status == "Submitted" ? (
            <div className="my-2">
              <button
                onClick={() => {
                  generateEInvoice(params.value);
                }}
                className="bg-transparent hover:bg-orange-400 p-1 hover:text-black-900 text-blue-700 font-semibold hover:text-white  border border-blue-500 hover:border-transparent rounded"
              >
                E-Invoice
              </button>
            </div>
          ) : (
            <span className="text-red-500 text-xs">In Draft</span>
          ),
        width: 130,
      },
      {
        headerName: "Credit NOTE",
        field: "id",
        cellRenderer: (params) =>
          params.data.irn ? (
            <button
              className="font-small text-blue-600 dark:text-blue-500 "
              onClick={(e) => {
                handleDownloadOriginalCreditNote(params);
              }}
              title="ORIGINAL COPY"
            >
              {/* Download One  */}
              <BsDownload className="w-4 h-4" />
            </button>
          ) : null,
        width: 120,
      },
      // {
      //   headerName: "CANCEL",
      //   field: "id",
      //   width: 100,
      //   cellRenderer: (params) =>
      //     params.data.irn &&
      //     params.data.fin_credit_note_status === "Submitted" ? (
      //       <button
      //         className="text-xs border border-red-500 text-red-500 hover:bg-red-500 hover:text-white-A700 transition-colors duration-200 rounded-md px-3 py-1"
      //         onClick={(e) => {
      //           // deleteDraftTaxInvoice(params.value);
      //           navigate(`/creditnote/cancel/einvoice/${params.value}`, {
      //             state: {
      //               irn: params.data.irn,
      //               fin_credit_note_status_id:
      //                 params.data.fin_credit_note_status_id,
      //               fin_customer_debit_note_id:
      //                 params.data.fin_customer_debit_note_id,
      //             },
      //           });
      //         }}
      //         title="Cancel Credit Note"
      //       >
      //         Cancel
      //       </button>
      //     ) : null,
      // },
      {
        headerName: "ACTIONS",
        field: "code",
        pinned: "right",
        cellRenderer: (params) => {
          const { showActionColumn, showViewColumn } = params.context;
          const { irn, fin_credit_note_status } = params.data;
          const getOptions = () => {
            let options = [];

            options.push({
              value: "Preview",
              label: "Preview",
              iconColor: "rgb(239 68 68)", // Set the icon color
              labelColor: "rgb(59 130 246)", // Set the label color
              icon: FaFilePdf,
              params: params,
            });

            if (showViewColumn) {
              options.push({
                value: "View",
                label: "View items",
                iconColor: "rgb(59 130 246)", // Set the icon color
                labelColor: "rgb(59 130 246)", // Set the label color
                icon: FaEye,
                params: params,
              });
            }
            // console.log(showActionColumn);
            if (
              showActionColumn &&
              params.data.fin_credit_note_status === "Draft"
            ) {
              options.push({
                value: "Submit",
                label: "Submit",
                iconColor: "rgb(34 197 94)", // Set the icon color
                labelColor: "rgb(34 197 94)", // Set the label color
                icon: FaCheck,
                params: params,
              });
            }

            if (
              showActionColumn &&
              params.data.fin_credit_note_status_id === 1
            ) {
              options.push({
                value: "Delete",
                label: "Delete",
                iconColor: "rgb(239 68 68)", // Set the icon color
                labelColor: "rgb(239 68 68)", // Set the label color
                icon: RiDeleteBin6Line,
                params: params,
              });
            }
            if (params.data.irn) {
              options.push({
                value: "DownloadOriginal",
                label: "Download Original Copy",
                iconColor: "rgb(59 130 246)", // Set the icon color
                labelColor: "rgb(59 130 246)", // Set the label color
                icon: BsDownload,
                params: params,
              });
              options.push({
                value: "DownloadAllCopy",
                label: "Download All Copy",
                iconColor: "rgb(59 130 246)", // Set the icon color
                labelColor: "rgb(59 130 246)", // Set the label color
                icon: BsDownload,
                params: params,
              });
            }
            if (irn) {
              // If E-Invoice is already generated
              options.push({
                value: "E-Invoice Generated",
                label: "E-Invoice Generated",
                iconColor: "rgb(34 197 94)", // Tailwind's green-500
                labelColor: "rgb(34 197 94)",
                icon: MdDone, // You can use a different icon if you want
                disabled: true, // Optionally disable the option since it's already generated
                params: params,
              });
            } else if (fin_credit_note_status === "Submitted") {
              // If the note is submitted and E-Invoice is not generated
              options.push({
                value: "E-Invoice",
                label: "E-Invoice",
                iconColor: "rgb(59 130 246)", // Tailwind's blue-500
                labelColor: "rgb(59 130 246)",
                icon: RiAiGenerate,
                params: params,
              });
            } else {
              // If it's still in Draft
              options.push({
                value: "In Draft",
                label: "In Draft",
                iconColor: "rgb(239 68 68)", // Tailwind's red-500
                labelColor: "rgb(239 68 68)",
                icon: CiWarning, // Optional: use a warning icon here instead
                disabled: true, // You can disable it to prevent user action
                params: params,
              });
            }
            if (params.data.fin_customer_debit_note_id) {
              options.push({
                value: "Download Debit Note",
                label: "Download Debit Note",
                iconColor: "rgb(59 130 246)", // Set the icon color
                labelColor: "rgb(59 130 246)", // Set the label color
                icon: BsDownload,
                params: params,
              });
            }
            if (
              showActionColumn &&
              params.data.irn &&
              params.data.fin_credit_note_status_id === 2
            ) {
              options.push({
                value: "Cancel",
                label: "Cancel",
                iconColor: "rgb(239 68 68)", // Set the icon color
                labelColor: "rgb(239 68 68)", // Set the label color
                icon: MdCancel,
                params: params,
              });
            }

            return options;
          };

          const options = getOptions();

          return (
            <div style={{ width: "100%", position: "relative", zIndex: 999 }}>
              <Select
                options={options}
                isSearchable={false}
                onChange={handleNavigation}
                placeholder={params.value || "ACTION"}
                menuPlacement="bottom"
                menuPortalTarget={selectRef.current} // Render the menu in the body
                // styles={actionbuttonCustomStyle}
                styles={updatedActionButtonCustomStyle}
                value={null} // Ensure no value is selected
                components={{ Option: CustomOption }} // Use the custom option component
              />
            </div>
          );
        },
        width: 180,
      },
    ];

    const customColDefs = [
      ...defaultColDefs,
      ...(showActionColumn
        ? [
            {
              headerName: "CANCEL",
              field: "id",
              width: 100,
              cellRenderer: (params) =>
                params.data.irn &&
                params.data.fin_credit_note_status === "Submitted" ? (
                  <button
                    className="text-xs border border-red-500 text-red-500 hover:bg-red-500 hover:text-white-A700 transition rounded-md px-3 py-1"
                    onClick={() =>
                      navigate(`/creditnote/cancel/einvoice/${params.value}`, {
                        state: {
                          irn: params.data.irn,
                          fin_credit_note_status_id:
                            params.data.fin_credit_note_status_id,
                          fin_customer_debit_note_id:
                            params.data.fin_customer_debit_note_id,
                        },
                      })
                    }
                  >
                    Cancel
                  </button>
                ) : null,
            },
          ]
        : []),
      ...(showViewColumn
        ? [
            {
              headerName: "Actions",
              field: "id",
              cellRenderer: (params) => (
                <button
                  className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                  onClick={() => {
                    navigate(`/creditNote/item/${params.value}`, {
                      state: { tax_invoice_id: params.data.tax_invoice_id },
                    });
                  }}
                >
                  <FaEye />
                </button>
              ),
              width: 100,
              filter: false,
            },
          ]
        : []),
    ];

    const [colDefs, setColDefs] = useState([]);
    useEffect(() => {
      setColDefs(showActionColumn ? customColDefs : defaultColDefs);
    }, [showActionColumn]);
    const ColDefaultVale = { filter: true };

    const gridOptions = {
      overlayNoRowsTemplate: `
        <div id="progress-bar-id" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
        </div>
    `,
    };
    return (
      <>
        {erplist.some((item) => item.erp_module_id === 59 && item.view) ? (
          <div>
            <ToastContainer />
            <div
              className="ag-theme-quartz"
              id="tab-grid-table"
              ref={selectRef}
              // style={customeStyle}
            >
              <AgGridReact
                ref={gridRef}
                rowData={creditNoteList.map((creditNoteList, index) => ({
                  ...creditNoteList,
                  sr: index + (offsetforSR + 1),
                }))}
                context={{ showActionColumn, showViewColumn }} // Pass `showActionColumn` through context
                columnDefs={colDefs}
                defaultColDef={ColDefaultVale}
                suppressMenuHide={true}
                suppressExcelExport={true}
                rowHeight={37}
                overlayLoadingTemplate={loading ? "Loading..." : null}
                overlayNoRowsTemplate={
                  loading
                    ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                    : "No Record Found"
                }
              />
            </div>
            <div>
              <Pagination
                count={count}
                setRecordPerPage={setRecordPerPage}
                recordPerPage={recordPerPage}
                setLoading={setLoading}
                setData={setCreditNoteList}
                setPage={setPage}
                page={page}
              />
            </div>
            {isOpen && (
              <WearHouseSelect
                options={wareHouse}
                setSubmitObj={setSubmitObj} // pass this
                submitObj={submitObj} // pass this if needed
                setInventoryMovement={setInventoryMovement}
                inventoryMovement={inventoryMovement}
                handleSubmit={handleSubmit}
                setIsOpen={setIsOpen}
              />
            )}
          </div>
        ) : (
          <div className="flex justify-center items-center h-screen">
            <div className="text-4xl text-red-500">No Access</div>
          </div>
        )}
      </>
    );
  }
);

const WearHouseSelect = ({
  options,
  onChange,
  handleSubmit,
  setIsOpen,
  inventoryMovement,
  setInventoryMovement,
  setSubmitObj,
  submitObj,
}) => {
  const [visible, setvisible] = useState(true);
  const customStyle = {
    content: {
      width: "40%",
      height: "40%",
      margin: "auto",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  };
  return (
    <>
      <Modal isOpen={visible} style={customStyle} onRequestClose={() => {}}>
        <div className="flex flex-col h-full gap-5 justify-center ">
          <Select
            options={options}
            onChange={(selectedOption) => {
              onChange?.(selectedOption); // optional, for other logic
              setSubmitObj((prev) => ({
                ...prev,
                company_warehouse_id: selectedOption.value,
              }));
            }}
          />
          <div className="mt-auto flex justify-center items-center gap-2">
            <button
              className="bg-blue-500 text-white-A700 px-4 py-2 rounded"
              onClick={() => {
                handleSubmit(submitObj);
              }}
            >
              Submit
            </button>
            <button
              className="bg-red-500 text-white-A700 px-4 py-2 rounded"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CreditNoteList;
